module.exports = __webpack_public_path__ + "img/Magento.a3cab32d.svg";